import VendorForm from '../../MyCommunity/Vendors/VendorCreation/General/VendorForm/VendorForm'
import { CustomForm } from 'components/Forms/CustomForm'
import { VendorDetailsForm } from '../../MyCommunity/Vendors/VendorCreation/General/DetailsForm/types'
import { FloatFooter } from '../../../components/FloatFooter/FloatFooter'
import { BTN_TXT } from '../../../constants'
import { validateMessages } from '../../MyCommunity/Vendors/VendorCreation/constants'
import { useVendorDetailsContext } from '../Providers/VendorDetailsContextProvider'
import { ACTIONS, SUBJECTS } from '../Abilities'
import { useVendorDetailsAbility } from '../Providers/AbilityProvider'
import './styles.scss'
import { useState } from 'react'
import { ConfirmChangesModal } from './ConfirmChangesModal'

export const VendorDetails = ({ businessDetails }) => {
  const { state, actions } = useVendorDetailsContext()
  const { form, phoneNumber, isActive, hasFormChanges, errors } = state
  const {
    onSubmit,
    setIsActive,
    handleChangeForm,
    resetFormChanges,
    getErrorField
  } = actions
  const ability = useVendorDetailsAbility()

  const [isShowConfirmationModal, setShowConfirmationModal] = useState(false)
  const onSaveForm = () => {
    setShowConfirmationModal(true)
  }

  return (
    <CustomForm<VendorDetailsForm>
      id="vendor-edit-form"
      form={form}
      onChange={handleChangeForm}
      onFinish={onSubmit}
      validateMessages={validateMessages}
      initialValues={{}}
      onFieldsChange={() => setIsActive(true)}
    >
      <VendorForm
        form={form}
        phoneNumber={phoneNumber}
        businessDetails={businessDetails}
        isCreation={false}
        disabled={ability.cannot(ACTIONS.EDIT, SUBJECTS.VENDOR_DETAILS)}
        errors={errors}
        getVendorError={getErrorField}
        disableNamesSearch
      />
      <FloatFooter
        isActive={isActive || hasFormChanges}
        onCancel={resetFormChanges}
        onSave={onSaveForm}
        saveBtnText={BTN_TXT.SAVE}
      />
      <ConfirmChangesModal
        visible={isShowConfirmationModal}
        close={() => setShowConfirmationModal(false)}
        handleSubmit={form.submit}
      />
    </CustomForm>
  )
}
